import type { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { clearPostLoginRedirect, getPostLoginRedirect } from 'common/auth/postLoginRedirect';
import { selectIsDeviceHandoffInProgress } from 'common/deviceHandoff/state/selectors';
import type { ComponentWithoutHOCProps } from 'common/types/component';

import { withAuthLayout } from '../login/withAuthLayout';

const _OktaPostLogoutCallback = (): ReactElement => {
    const isDeviceHandoffInProgress = useSelector(selectIsDeviceHandoffInProgress);
    const postLoginRedirectUrl = getPostLoginRedirect();

    // `postLoginRedirect` belongs to the incoming user's post-login sign-in (consumed by
    // `AuthUserLandingPage` / `OktaPostLoginCallback`), not to this outgoing-user logout — leave it untouched.
    if (isDeviceHandoffInProgress) {
        return <Navigate to="/deviceHandoff" replace />;
    }

    if (postLoginRedirectUrl) {
        clearPostLoginRedirect();

        return <Navigate to={postLoginRedirectUrl} replace />;
    }

    return <Navigate to="/" replace />;
};

const OktaPostLogoutCallback: ComponentWithoutHOCProps<null> = withAuthLayout(_OktaPostLogoutCallback);
export default OktaPostLogoutCallback;
